import React, { useContext } from 'react';

import SideFiltersNavItem from './SideFiltersNavItem';
import Context from "../context/context";

function SideFiltersNav(props) {
  const {
    form,
  } = props;

  const {
    activeFilters, setActiveFilters,
    selectedFilters, setSelectedFilters,
    setStartDate,
    setEndDate
  } = useContext(Context);

  const bg_active = activeFilters.active_side_filter.length;

  const handleSideNavItemClick = (name) => {
    let active_filters = activeFilters;

    form.forEach((form_section) => {
      if (form_section.name == name) {
        if (active_filters.active_side_filter === name) {
          active_filters.active_side_filter = '';
          active_filters.active_date_panel = '';
        } else {
          active_filters.active_side_filter = name;
        }
      }
    })
    setActiveFilters(
      { ...activeFilters },
      active_filters
    )
  }

  const closeFilterPanel = () => {
    let active_filters = {
      mobile_open: false,
      active_panel: 'side_filter',
      top_filter_open: false,
      side_filter_open: false,
      active_side_filter: '',
      active_date_panel: ''
    };


    setActiveFilters(
      active_filters
    )
  }


  const resetAllFilters = () => {
    let active_filter = activeFilters.active_side_filter;

    let selected_filters = selectedFilters.map((selected_filter) => {
      if (selected_filter.name === active_filter || active_filter === "") {

        if (selected_filter.type === "checkboxes") {
          selected_filter.elements.forEach((element) => {
            element.value = false;
          })
        }
        if (selected_filter.type === "date") {
          selected_filter.elements.forEach((element) => {
            element.value = "";
          })
          setStartDate("");
          setEndDate("");
        }
      }


      return selected_filter;
    })
    setSelectedFilters(selected_filters);
  }

  return (
    <>
      <div className={`side-filters-nav ${bg_active ? 'active' : ''}`}>
        <div className="side-filters-title font-30-35">Filter by:</div>

        <div className={`side-filters-nav-bg ${bg_active ? 'active' : ''}`}></div>
        {form.map((form_section) => {
          if (form_section.type == "checkboxes" || form_section.type == "date") {
            return <SideFiltersNavItem key={form_section.name} data={form_section} handleClick={() => (handleSideNavItemClick(form_section.name))} />
          }
        }

        )}

        <div className="filter-actions">
          <button
            className="filter-action view button button-white"
            onClick={() => closeFilterPanel()}
          >
            View results
          </button>
          <button
            className="filter-action reset button"
            onClick={() => resetAllFilters()}
          >
            Reset these filters
          </button>
        </div>

      </div>
    </>
  )
}

export default SideFiltersNav;
